import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CenterService } from 'src/app/private/services/center.service';
import { ClientService } from 'src/app/private/services/client.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-client',
  imports: [SharedModule],
  templateUrl: './delete-client.component.html',
  styleUrl: './delete-client.component.scss'
})
export class DeleteClientComponent {

  @Input() clientDataToEdit: any = {};
  @Input() clientId: string = '';
  isLoading = false;

  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();

  constructor(
    private clientService: ClientService,
    private messageService: MessageService
  ) { }


  handleCloseDialog() {
    this.close.emit();
  }

  handleDeleteDepartment() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      client_id:this.clientDataToEdit.client_id,
    };
    this.clientService.deleteClient(payload).subscribe(
      {
        next: (res: any) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Department deleted successfully'
          });
          this.reload.emit(); // Emit reload event to parent component
          this.close.emit(); // Emit close event to parent component
        },
        error: (err) => {
          this.isLoading = false; // Reset loading state
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message || 'An error occurred while deleting the department'
          });
        }
      }
    );
  }


}
